!function(window) {
/* BEGIN MAP */

let map = null;


function getMap(){
	if(map == null){
		initializeLeafletMap();
	}
}

function validateSize(){
	if(map != null){
		map.invalidateSize();
	}
}

function initializeLeafletMap() {
	let selector = 'leaflet-map'
	let mapSelector = $(`#${selector}`);
	let markerLayer = null;
	let strid = mapSelector.attr('data-strid');
	let dataid = mapSelector.attr('data-did');
	let lang = mapSelector.attr('data-lng');

	// last shown, if clicked on same nothing happens
	let last = null;

	if (mapSelector.length) {		
		map = new L.map(selector)
		L.tileLayer('https://{s}.basemaps.cartocdn.com/rastertiles/voyager_labels_under/{z}/{x}/{y}{r}.png', {
			attribution: '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors &copy; <a href="https://carto.com/attributions">CARTO</a>',
			subdomains: 'abcd',
			maxZoom: 15,
			minZoom:7,
			zoomControl: false
		}).addTo(map);
		
		markerLayer = new L.layerGroup();
		map.addLayer(markerLayer);
		map.scrollWheelZoom.disable();
		
		if(strid != '4_'+lang){
			getLeafletMarkers(map, markerLayer, strid, dataid, lang);
		}else{
			if(dataid != ''){
				getLeafletPath(strid, lang, dataid);
			}else{
				getAllLeafletPaths(strid, lang);
			}
		}
	}

	function getLeafletMarkers(map, markerLayer, strid, dataid, lang) {
		const ajaxOpts = {
			'func': 'associations-markers',
			'type': strid,
			'dataId': dataid,
			'lang': lang
		}

		$.post('/util/ajaxresponse.php', ajaxOpts, data => {
			
			// clear previous just in case
			markerLayer.clearLayers();
			if (data.length) {
				const bounds = [];
				const leafletIconPoint = new L.icon({
					iconUrl: '/images/backgrounds/icons/pin3.svg',
					iconSize: [35, 42],
					iconAnchor: [16, 16]
				});

			
				for (const assoc of data) {
					bounds.push([assoc.lat, assoc.long]);

					var marker = L.marker([assoc.lat, assoc.long], {
						icon: leafletIconPoint,
					});

					var link = assoc.url+''+assoc.id+'/';
					const pop = new L.popup();
					pop.setContent('<h2>'+assoc.naslov+'</h2><a class="link" href="'+link+'">več</a>');
					if(assoc.type != 'point'){
						marker.bindPopup(pop);
					}
				
					/*marker.on('click', () => {
						if (assoc.id && assoc.id != last) {
							getSodelovanjeData(assoc.id);				
						}
					});	*/	

					markerLayer.addLayer(marker);
				}		
				map.fitBounds(bounds);
			}
		});
	}

	function getLeafletPath(strid, lang, dataid){		
		$.get('/util/ajaxresponse.php?lng='+lang+'&strid='+strid+'&func=associations-path&path_id='+dataid, data => {
			console.log(data);
		
			var gpx = data['gpxfile']; // URL to your GPX file or the GPX itself
			if(gpx == '') {
				map.setView(new L.LatLng(45.683351, 13.9431396), 12);
			} else {
				new L.GPX(gpx, {
					async: true,
					marker_options: {
						wptIconUrls: {
							'': '/images/backgrounds/icons/pin3.svg',
							'lago': '/images/pin-icon-end.png'
						},
						startIconUrl: '/images/backgrounds/icons/pin-start.svg',
						endIconUrl: '',
						shadowUrl: '',
						iconSize: [21, 21],
						iconAnchor: [11, 11]
					},
					polyline_options: {
						color: '#d94e32',
						opacity: 1,
						weight: 4,
						lineCap: 'round'
					}
					}).on('addpoint', function(e) {
						console.log('Added ' + e.point_type + ' point: ' + e.point_type);
					}).on('loaded', function (e) {
						var gpx = e.target;
						map.fitBounds(gpx.getBounds());
					}).addTo(map);
			}
			

			
		});
	}


	function getAllLeafletPaths(strid, lang){	
		$.get('/util/ajaxresponse.php?lng='+lang+'&strid='+strid+'&func=associations-path', data => {
			var numOfPath = data.length-1;
			var allPaths = 1;
			let aGpx = [];
			for (const assoc of data) {
				if(assoc.fileId == null)
					continue;
					
				var gpx = assoc.gpxfile; // URL to your GPX file or the GPX itself
				var wtf = new L.GPX(gpx, {
					async: true,
					marker_options: {
						wptIconUrls: {
							'': '/images/pin-icon-start.png',
							'lago': '/images/pin-icon-end.png'
						},
						startIconUrl: '',
						endIconUrl: '',
						shadowUrl: ''
					},
					polyline_options: {
						color: '#d94e32',
						opacity: 1,
						weight: 4,
						lineCap: 'round',
						footPathHref: assoc.url+assoc.id
					}
				}).on('addpoint', function(e) {
					console.log('Added ' + e.point_type + ' point: ' + e.point_type);
				}).on({
					mouseover: function(e) {
						// _poli je custom napisan v gpx.min.js file-u, da dobi polyline objekt (*predelava);
						var oPolyLine = e.target._poli;
						oPolyLine.setStyle({weight: 9, color:'#6932bc'});
					},
					mouseout: function(e) {	
						var oPolyLine = e.target._poli;
						oPolyLine.setStyle({weight: 4, color:'#d94e32'});
					}
				}).on('click', function(e) {
					//var pathFile = e.target._gpx.split("/");	
					//markItem(pathFile[pathFile.length-2]);
					window.location.href = e.layer.options.footPathHref;
				}).on('loaded', (e) => {
					var gpx = e.target;	
					var cord = gpx.getBounds();
					aGpx.push([cord._northEast.lat, cord._northEast.lng],[cord._southWest.lat, cord._southWest.lng]);
		
					if(numOfPath == 1){ // da na zadnjem gpx file naredi bounds ker izven on loada aGpx ni dostopen
						var aBounds = L.latLngBounds(aGpx);
						map.fitBounds(aBounds);
					}
					numOfPath--;
					
				}).addTo(map);			
			}
		});
	}

	
	/*function getSodelovanjeData(id) {

		const ajaxOpt = {
			'func': 'association-data-center',
			'id': id
		}
		$.post('/util/ajaxresponse.php', ajaxOpt, html => {
			$('#additional-data').empty();
			$('#additional-data').append(html);

			// zaradi ajaxa je potrebno magnific še enkrat poklicat
			$("a[rel^='magnific']").magnificPopup({
				type: 'image',
				gallery: {
					enabled: true,
					navigateByImgClick: true,
					tCounter: '%curr%\/%total%'
				},
				closeBtnInside: false,
				closeOnBgClick: true
			});

		});
	}*/

}
/* END MAP */

module.exports = {accomodation : getMap, validate : validateSize};
window.map = map;
window.getMap = getMap;
window.validateSize = validateSize;
window.initializeLeafletMap = initializeLeafletMap;
}(window);